import { isEmbedded } from '../../public/lib/PageHelpers.js';
import { FormPart, part } from '~/lib/FormCssApi';

const FormHeaderBlock = ({ styles, className, objectId, objectType }) => {
    const headerImage = !styles?.fullPageImage && styles?.headerImage;
    const headerColor = !styles?.fullPageImage && styles?.headerColor;
    const headerPadding = `${styles?.headerHeight || 0}px`;
    const logo = !styles?.logoDisabled && styles?.logo;
    const headerPosition = styles?.headerImagePosition
        ? `50% ${styles?.headerImagePosition}%`
        : 'center';

    if (!headerImage && !headerColor && !logo) {
        return null;
    }

    if (isEmbedded()) {
        // Don't show header when embedded
        return null;
    }

    return (
        <div
            {...part(FormPart.HEADER)}
            className={`w-full py-6 ${!logo && headerImage ? 'min-h-64' : ''} ${className} flex items-center justify-center`}
            style={{
                backgroundImage: `url(${headerImage})`,
                backgroundSize: 'cover',
                backgroundPosition: headerPosition,
                backgroundColor: headerColor,
                paddingTop: headerPadding,
                paddingBottom: headerPadding,
            }}
        >
            {!!logo && (
                <img
                    {...part(FormPart.LOGO)}
                    src={`/forms/${objectType}/${objectId}/logo?${logo}`}
                    alt="Logo"
                    className={`max-h-48 ${styles?.logoShadow ? 'shadow-lg' : ''}`}
                />
            )}
        </div>
    );
};

export default FormHeaderBlock;
